// extracted by mini-css-extract-plugin
module.exports =  {"icon":"SvgIcon__icon--OF"};